export const buyNowABI = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
      }
    ],
    name: 'AdminApproved',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
      }
    ],
    name: 'AdminRevoked',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'admin',
        type: 'address'
      }
    ],
    name: 'approveAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'saleId',
            type: 'string'
          },
          {
            internalType: 'address',
            name: 'tokenOwner',
            type: 'address'
          },
          {
            internalType: 'uint256',
            name: 'tokenId',
            type: 'uint256'
          },
          {
            internalType: 'uint64',
            name: 'tokenQuantity',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'quantity',
            type: 'uint64'
          },
          {
            internalType: 'address',
            name: 'buyer',
            type: 'address'
          },
          {
            internalType: 'string[]',
            name: 'tokenUris',
            type: 'string[]'
          },
          {
            internalType: 'address',
            name: 'paymentToken',
            type: 'address'
          },
          {
            internalType: 'uint256',
            name: 'paymentAmount',
            type: 'uint256'
          }
        ],
        internalType: 'struct OnchainBuy.BuyList',
        name: 'list',
        type: 'tuple'
      },
      {
        internalType: 'uint256',
        name: 'tax',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint16',
            name: 'discountPercentage',
            type: 'uint16'
          },
          {
            internalType: 'uint32',
            name: 'expirationTime',
            type: 'uint32'
          },
          {
            internalType: 'string',
            name: 'nonce',
            type: 'string'
          },
          {
            internalType: 'bytes',
            name: 'signature',
            type: 'bytes'
          },
          {
            internalType: 'address',
            name: 'signer',
            type: 'address'
          }
        ],
        internalType: 'struct OnchainBuy.Discount',
        name: 'discount',
        type: 'tuple'
      }
    ],
    name: 'buy',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenContract',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'buyer',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tax',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'paymentAmount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'mintedNfts',
        type: 'uint256[]'
      }
    ],
    name: 'BuyExecuted',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'metadataURI',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256'
      }
    ],
    name: 'BuyNowCreated',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      },
      {
        internalType: 'bool',
        name: 'isContactGallery',
        type: 'bool'
      },
      {
        internalType: 'bool',
        name: 'isSold',
        type: 'bool'
      },
      {
        internalType: 'address',
        name: 'buyer',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      }
    ],
    name: 'cancelSale',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      }
    ],
    name: 'ContactGallery',
    type: 'event'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint64',
            name: 'nftStartTokenId',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'nftEndTokenId',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'maxCap',
            type: 'uint64'
          },
          {
            internalType: 'uint256',
            name: 'startDate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'endDate',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'nftContractAddress',
            type: 'address'
          },
          {
            internalType: 'uint256',
            name: 'minimumFiatPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256[]',
            name: 'minimumCryptoPrice',
            type: 'uint256[]'
          },
          {
            internalType: 'address[]',
            name: 'paymentCurrency',
            type: 'address[]'
          },
          {
            components: [
              {
                internalType: 'address payable',
                name: 'paymentSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'taxSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'commissionAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'platformSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'uint16',
                name: 'commissionFeePercentage',
                type: 'uint16'
              },
              {
                internalType: 'uint16',
                name: 'platformFeePercentage',
                type: 'uint16'
              }
            ],
            internalType: 'struct OnchainBuy.settlementList',
            name: 'paymentSettlement',
            type: 'tuple'
          },
          {
            internalType: 'enum OnchainBuy.TransactionStatus',
            name: 'transactionStatus',
            type: 'uint8'
          },
          {
            internalType: 'enum OnchainBuy.PaymentStatus',
            name: 'paymentStatus',
            type: 'uint8'
          }
        ],
        internalType: 'struct OnchainBuy.PriceList',
        name: 'list',
        type: 'tuple'
      },
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      },
      {
        internalType: 'bool',
        name: 'enableSignature',
        type: 'bool'
      }
    ],
    name: 'createOrUpdateSale',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_platformAddress',
        type: 'address'
      },
      {
        internalType: 'uint16',
        name: '_platformFeePercentage',
        type: 'uint16'
      },
      {
        internalType: 'uint64',
        name: '_max1155Quantity',
        type: 'uint64'
      },
      {
        internalType: 'contract IPriceFeed',
        name: '_priceFeedAddress',
        type: 'address'
      },
      {
        internalType: 'contract IRoyaltyEngine',
        name: '_royaltycontract',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: '_adminApprovalRequired',
        type: 'bool'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8'
      }
    ],
    name: 'Initialized',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'admin',
        type: 'address'
      }
    ],
    name: 'revokeAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'tokenContract',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'RoyaltyPayout',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      }
    ],
    name: 'saleClosed',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: 'uint64',
            name: 'nftStartTokenId',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'nftEndTokenId',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'maxCap',
            type: 'uint64'
          },
          {
            internalType: 'uint256',
            name: 'startDate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'endDate',
            type: 'uint256'
          },
          {
            internalType: 'address',
            name: 'nftContractAddress',
            type: 'address'
          },
          {
            internalType: 'uint256',
            name: 'minimumFiatPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256[]',
            name: 'minimumCryptoPrice',
            type: 'uint256[]'
          },
          {
            internalType: 'address[]',
            name: 'paymentCurrency',
            type: 'address[]'
          },
          {
            components: [
              {
                internalType: 'address payable',
                name: 'paymentSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'taxSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'commissionAddress',
                type: 'address'
              },
              {
                internalType: 'address payable',
                name: 'platformSettlementAddress',
                type: 'address'
              },
              {
                internalType: 'uint16',
                name: 'commissionFeePercentage',
                type: 'uint16'
              },
              {
                internalType: 'uint16',
                name: 'platformFeePercentage',
                type: 'uint16'
              }
            ],
            internalType: 'struct OnchainBuy.settlementList',
            name: 'paymentSettlement',
            type: 'tuple'
          },
          {
            internalType: 'enum OnchainBuy.TransactionStatus',
            name: 'transactionStatus',
            type: 'uint8'
          },
          {
            internalType: 'enum OnchainBuy.PaymentStatus',
            name: 'paymentStatus',
            type: 'uint8'
          }
        ],
        indexed: false,
        internalType: 'struct OnchainBuy.PriceList',
        name: 'saleList',
        type: 'tuple'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'CreatedOrUpdated',
        type: 'string'
      }
    ],
    name: 'saleCreated',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'approval',
        type: 'bool'
      }
    ],
    name: 'setAdminApproval',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_platformAddress',
        type: 'address'
      },
      {
        internalType: 'uint16',
        name: '_platformFeePercentage',
        type: 'uint16'
      },
      {
        internalType: 'uint64',
        name: '_max1155Quantity',
        type: 'uint64'
      },
      {
        internalType: 'address',
        name: '_royaltyContract',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_pricefeed',
        type: 'address'
      }
    ],
    name: 'setContractData',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    stateMutability: 'payable',
    type: 'fallback'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'paymentCurrency',
        type: 'address'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    stateMutability: 'payable',
    type: 'receive'
  },
  {
    inputs: [],
    name: 'adminApprovalRequired',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32'
      }
    ],
    name: 'discountUsed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getAdmins',
    outputs: [
      {
        internalType: 'address[]',
        name: 'admins',
        type: 'address[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getContractData',
    outputs: [
      {
        internalType: 'address',
        name: '_platformAddress',
        type: 'address'
      },
      {
        internalType: 'uint16',
        name: '_platformFeePercentage',
        type: 'uint16'
      },
      {
        internalType: 'contract IPriceFeed',
        name: '_priceFeedAddress',
        type: 'address'
      },
      {
        internalType: 'contract IRoyaltyEngine',
        name: '_royaltySupport',
        type: 'address'
      },
      {
        internalType: 'uint64',
        name: '_max1155Quantity',
        type: 'uint64'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string'
      }
    ],
    name: 'getListingPrice',
    outputs: [
      {
        internalType: 'uint256[]',
        name: 'minimumCryptoPrice',
        type: 'uint256[]'
      },
      {
        internalType: 'address[]',
        name: 'paymentCurrency',
        type: 'address[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'collectionAddress',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      }
    ],
    name: 'getRoyaltyInfo',
    outputs: [
      {
        internalType: 'address payable[]',
        name: 'recipients',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'bps',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'admin',
        type: 'address'
      }
    ],
    name: 'isAdmin',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    name: 'listings',
    outputs: [
      {
        internalType: 'uint64',
        name: 'nftStartTokenId',
        type: 'uint64'
      },
      {
        internalType: 'uint64',
        name: 'nftEndTokenId',
        type: 'uint64'
      },
      {
        internalType: 'uint64',
        name: 'maxCap',
        type: 'uint64'
      },
      {
        internalType: 'uint256',
        name: 'startDate',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'nftContractAddress',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'minimumFiatPrice',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'address payable',
            name: 'paymentSettlementAddress',
            type: 'address'
          },
          {
            internalType: 'address payable',
            name: 'taxSettlementAddress',
            type: 'address'
          },
          {
            internalType: 'address payable',
            name: 'commissionAddress',
            type: 'address'
          },
          {
            internalType: 'address payable',
            name: 'platformSettlementAddress',
            type: 'address'
          },
          {
            internalType: 'uint16',
            name: 'commissionFeePercentage',
            type: 'uint16'
          },
          {
            internalType: 'uint16',
            name: 'platformFeePercentage',
            type: 'uint16'
          }
        ],
        internalType: 'struct OnchainBuy.settlementList',
        name: 'paymentSettlement',
        type: 'tuple'
      },
      {
        internalType: 'enum OnchainBuy.TransactionStatus',
        name: 'transactionStatus',
        type: 'uint8'
      },
      {
        internalType: 'enum OnchainBuy.PaymentStatus',
        name: 'paymentStatus',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    name: 'signatureEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    name: 'tokensUsed',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    name: 'usedSaleId',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
];
